var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-header"}},[_c('div',{attrs:{"id":"header"}},[_c('app-header-logo'),_c('app-header-nav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }